import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { LoggerService } from '../../services';
import { TaggedLogger } from '../../services';
import { Table } from 'primeng';

import { InputHelper } from '../../utils/input.helper';
import { RateCardCellDataEvent } from '../../interfaces/rate-card-presets/rate-card-cell-data-event.interface';
import { IRateCard } from 'src/app/interfaces/ratecard';
import { IPricingBanding } from '../../interfaces/pricing-banding';
import { IRateCardInclusivityType } from '../../interfaces/ratecard-inclusivity-type';

@Component({
  selector: 'rate-card-grid',
  templateUrl: './rate-card-grid.component.html',
  styleUrls: ['./rate-card-grid.component.css'],
  encapsulation: ViewEncapsulation.None, // todo: check
})
export class RateCardGridComponent implements OnInit {
  private logger: TaggedLogger;

  public priceBandingDialogVisible: boolean = false;
  public dlgBandings: IPricingBanding[];
  public dlgServiceCardId: number;

  @ViewChild('dtCards') dtCards: Table;
  @ViewChild('dtBandings') dtBandings: Table;

  public selectedItem: any;
  public selectedIndex: number;
  public selectedTab: number;
  public _datas: IRateCard[];
  @Output() datasChange: EventEmitter<any[]>;
  @Input('datas')
  public set datas(value: any[]) {
    this._datas = value;
    //this.logger.debug('datas set:', value);
    this.datasChange.emit(value);
  }
  public get datas(): IRateCard[] {
    if (this.showOfferedServicesOnly) {
      return this._datas.filter((o) => o.isServiceOffered);
    }
    return this._datas;
  }

  @Input() useBanding: boolean;

  @Input() pricesReadonly: boolean;

  @Input() agreementBandings: any[];

  @Input() isPostcodeBased: boolean;

  @Input() showOfferedServicesOnly: boolean;

  @Input() inclusivityTypes: IRateCardInclusivityType[];

  @Output() cellValueChanged: EventEmitter<RateCardCellDataEvent> =
    new EventEmitter<RateCardCellDataEvent>();

  constructor(public inputHelper: InputHelper, loggerService: LoggerService) {
    this.datasChange = new EventEmitter<any[]>();
    this.logger = loggerService.taggedLogger('component:rate-card-grid');
    this.logger.debug('constructed');
  }

  ngOnInit() {
    //this.logger.debug('ngOnInit, datas: ', this.datas);
  }

  emptyBanding(b: any[]) {
    return !b || b.find((o) => o.price > 0) == null;
  }

  editBanding(data: IRateCard) {
    const arr = [];

    this.agreementBandings.forEach((o) => {
      const a = {
        agreementPricingBandingId: o.id,
        from: o.from,
        to: o.to,
        price: 0,
        isFixedPrice: false,
      };
      arr.push(a);

      const b = data.pricing.bandings.find((p) => p.agreementPricingBandingId == o.id);
      if (b != null) {
        a.price = b.price;
        a.isFixedPrice = b.isFixedPrice ?? false;
      }
    });

    this.dlgBandings = arr;
    this.dlgServiceCardId = data.serviceCard.id;
    this.priceBandingDialogVisible = true;
  }

  priceBandingValid(bandings: IPricingBanding[]) {
    return bandings && bandings.find((o) => !o.price) == null;
  }

  dlgDeleteBanding() {
    const card = this.datas.find((o) => o.serviceCard.id == this.dlgServiceCardId);
    card.pricing.bandings.length = 0;
    this.priceBandingDialogVisible = false;
  }

  dlgSaveBanding() {
    const card = this.datas.find((o) => o.serviceCard.id == this.dlgServiceCardId);

    const arr = [];
    this.dlgBandings.forEach((o) => {
      const a = {
        agreementPricingBandingId: o.agreementPricingBandingId,
        price: o.price,
        isFixedPrice: o.isFixedPrice,
      };
      arr.push(a);
    });
    card.pricing.bandings = arr;
    this.priceBandingDialogVisible = false;
  }

  onRatecardPriceKeyDown(e, data, col) {
    if (this.inputHelper.allowNumberInputKey(e)) {
      if (e.which == 9 || e.which == 13 || e.which == 27) {
        const newValue = this.correctPriceOnBlur(e.currentTarget);
        data.pricing[col.field] = Number(newValue);
      }
    }
  }

  to2Digits(v) {
    return (Math.round(v * 100) / 100).toFixed(2);
  }

  correctPriceOnBlur(target, maxValue = 100) {
    const maxDigits = 2;

    const v = target.value;
    if (v > maxValue) {
      res = maxValue.toString();
    } else {
      const a = v.split('.');

      var res = '';
      if (a.length > 0) {
        if (a[0] > maxValue) {
          res = maxValue.toString();
        } else {
          if (a.length > 1 && a[1].length > maxDigits) a[1] = a[1].substring(0, maxDigits);

          res = (a[0] ? a[0] : '0') + (a.length > 1 && a[1] > 0 ? '.' + a[1] : '');
        }
      }

      if (res == '') res = '0';
    }

    target.value = res;
    return res;
  }

  onBandingCellBlur(e, data, col) {
    const newValue = this.correctPriceOnBlur(e.currentTarget, 999999);
    data.price = newValue;
  }

  isBand2Invalid(data) {
    return (
      data.band2LowerMileageThreshold != 0 && data.band2LowerMileageThreshold < data.includedMiles
    );
  }

  isBand3Invalid(data) {
    return (
      data.band3LowerMileage != 0 &&
      (data.band3LowerMileage < data.band2LowerMileageThreshold ||
        data.band3LowerMileage < data.includedMiles)
    );
  }

  onValueChanged(data: any, fieldName: string, rowIndex: number) {
    //console.log("VALUE CHANGED: ", fieldName, "  -  ", data, ": ", data.pricing[fieldName])
    this.cellValueChanged.emit({ fieldName, value: data.pricing[fieldName], rowIndex });
  }
}
